export default {
  'menu.aiScenes': 'アプリケーションシーン',
  'menu.workbench': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.myApps': 'マイアプリ',
  'menu.markets.apps': 'アプリマーケット',
  'menu.markets.skills': 'Skill マーケット',
  'menu.markets.mcp': 'MCP マーケット',
  'menu.markets.plugins': 'プラグインマーケット',
  'menu.businessAppMarket': '業務アプリマーケット',
  'menu.management': '企業管理',
  'menu.management.tenants': 'テナント管理',
  'menu.management.tenantDetail': 'テナント詳細',
  'menu.management.users': 'ユーザー管理',
  'menu.management.userDetail': 'ユーザー詳細',
  'menu.management.myTenants': 'テナント設定',
  'menu.management.myTenantDetail': 'テナント設定',
  'menu.management.identities': 'メンバー管理',
  'menu.management.departments': '部門管理',
  'menu.management.roles': '権限管理',
  'menu.platformManagement': 'プラットフォーム管理',
  'menu.platformManagement.applications': 'アプリ管理',
  'menu.platformManagement.pluginApplications': 'プラグインアプリ',
  'menu.platformManagement.applicationPublicationReview': 'アプリ公開審査',
  'menu.platformManagement.taxonomies': '分類法',
  'menu.platformManagement.aiRuntime': 'モデル広場',
  'menu.platformManagement.events': 'イベントエンジン',
  'menu.platformManagement.clusters': 'クラスター',
  'menu.platformManagement.applicationStorage': 'アプリストレージ',
  'menu.platformManagement.productCatalog': '商品カタログ',
  'menu.platformManagement.tenantPackages': 'プラン管理',
  'menu.platformManagement.tenantEntitlements': 'テナント権限',
  'menu.platformManagement.paymentOrders': '支払い注文',
  'menu.platformSettings': 'プラットフォーム設定',
  'menu.platformSettings.branding': 'ブランド',
  'menu.platformSettings.llm': '既定モデル',
  'menu.platformSettings.storage': '既定ストレージ',
  'menu.platformSettings.quota': '利用上限',
  'menu.platformSettings.features': 'プラットフォーム機能',
  'menu.platformSettings.permissions': 'プラットフォーム権限',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.settings': 'システム設定',
  'menu.settings.permissions': '権限管理',
  'menu.login': 'ログイン',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.account.switchTenant': '組織の切り替え',
  'menu.account.switchTenant.empty': '切り替え可能な組織がありません',
  'menu.account.switchTenant.create': '組織を作成/参加',
  'menu.account.switchTenant.delete': '組織を削除',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
};
